import { Icon } from 'components/atoms/Icons';
import TooltipAtom from 'components/atoms/TooltipAtom';
import { AlfredTableColumn } from 'components/organisms/AlfredTable';
import { PremiumUserCustomModel } from '../useTabUserList';
import './styles.scss';


export interface UserListColumnProps {
  columnLiterals: Record<string, string>,
}

export const UserListColumns = ({ columnLiterals }: UserListColumnProps): AlfredTableColumn<PremiumUserCustomModel>[] => {
  const {
    nameColumnTitle,
    emailColumnTitle,
    rolesColumnTitle,
    projectColumnTitle,
    userActiveColumnTitle,
    lastAccessColumnTitle,
    confirmedAtColumnTitle,
    userActiveTooltipText,
    notReportedText,
  } = columnLiterals;

  return [
    {
      title: nameColumnTitle,
      key: 'userName',
      width: '10%',
      dataIndex: 'userName',
    },
    {
      title: emailColumnTitle,
      key: 'userEmail',
      width: '30%',
      dataIndex: 'userEmail',
    },
    {
      title: rolesColumnTitle,
      key: 'userRoles',
      width: '15%',
      render: (text, { rolesLiterals }) => (
        <ul className='Column__cell'>
          {rolesLiterals.map((role: string, index: number) => {
            return (
              <li key={index}>
                <span>{role}</span>
              </li>
            )
          })}
        </ul >
      ),
    },
    {
      title: projectColumnTitle,
      key: 'userProjectList',
      width: '15%',
      render: (text, { userProjectList }) => (
        <ul className='Column__cell'>
          {userProjectList.map(({ projectId, projectName }) => {
            return (
              <li key={projectId}>
                <span>{projectName}</span>
              </li>
            )
          })}
        </ul>
      ),
    },
    {
      title: (
        <div className={'Column__tooltip'}>
          <span>{userActiveColumnTitle}</span>
          <TooltipAtom placement={'topRight'} title={userActiveTooltipText}>
            <Icon.InfoCircleFilled />
          </TooltipAtom>
        </div>
      ),
      key: 'userActive',
      width: '10%',
      dataIndex: 'userActiveText',
    },
    {
      title: lastAccessColumnTitle,
      key: 'userLastAccess',
      width: '10%',
      dataIndex: 'userLastAccess',
      render: (text, { userLastAccess }) => {
        return !!userLastAccess
          ? <span>{userLastAccess}</span>
          : <span className='Column__notReportedText'>{notReportedText}</span>
      },
    },
    {
      title: confirmedAtColumnTitle,
      key: 'userConfirmedAt',
      width: '10%',
      dataIndex: 'userConfirmedAt',
    },
  ];
};
